import { type ShoppingCategory } from '@/features/shop/services/ShoppingCategories/types'
import {
  type KeyboardHandler,
  type OnCategorySelect,
} from '@/features/shop/components/CategorySubNav/types'
import { Image } from '@/features/shared/elements/Image/NextImage'
import styled from 'styled-components'
import { fadeIn2 } from '@/features/shared/styles/effects'
import { Body } from '@shipt/design-system-typography'
import { Box } from '@shipt/design-system-layouts'

interface Props {
  subCategory: ShoppingCategory
  columnIndex: number
  onCategorySelect: OnCategorySelect
  keyboardHandler: KeyboardHandler
}

export const CategoryH2 = ({
  subCategory,
  columnIndex,
  onCategorySelect,
  keyboardHandler,
}: Props) => {
  const { name, children, image_url: imageUrl } = subCategory
  const displayName = name
  return (
    <CategoryWrapper
      tabIndex={-1}
      role="menuitem"
      onClick={() => onCategorySelect(subCategory, columnIndex, 0)}
      onKeyDown={(e) => keyboardHandler(e, subCategory, columnIndex, 0)}
    >
      <CategoryImage src={imageUrl ?? ''} fallbackType="category" alt="" height={64} width={64} />
      <Box marginBottom="sm">
        <CategoryName strong>{displayName}</CategoryName>
      </Box>
      {children?.map((child, index) => {
        const rowIndex = index + 1
        const childDisplayName = child.name
        return (
          <SubCategory
            key={child.id}
            onClick={(e) => {
              e.stopPropagation()
              onCategorySelect(child, columnIndex, rowIndex)
            }}
            tabIndex={-1}
            onKeyDown={(e) => {
              e.stopPropagation()
              keyboardHandler(e, child, columnIndex, rowIndex)
            }}
            size="sm"
            variant="secondary"
          >
            {childDisplayName}
          </SubCategory>
        )
      })}
    </CategoryWrapper>
  )
}

const CategoryWrapper = styled.div`
  min-width: 7.5rem;
  max-width: 11.25rem;
  cursor: pointer;
`

const CategoryImage = styled(Image)`
  padding-left: 1rem;
  padding-right: 1rem;
  animation: ${fadeIn2};
`

const CategoryName = styled(Body)`
  &:hover,
  &:focus {
    color: ${({ theme }) => theme.color.content.action.primary_hover};
  }
`

const SubCategory = styled(Body)`
  margin-bottom: 0.25rem;

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.color.content.action.primary};
  }
`
